const eCommerceOriginConstants = (function() {

    'use strict';

    return {
        'CERTIFICATE_PAYWALL': 'certificate',
        'QUIZ_ACTIVITY_PAYWALL': 'quiz',
        'GRAMMAR_DISCOVER_ACTIVITY_PAYWALL': 'grammar_discover',
        'GRAMMAR_DEVELOP_ACTIVITY_PAYWALL': 'grammar_develop',
        'GRAMMAR_PRACTICE_ACTIVITY_PAYWALL': 'grammar_practice',
        'CONVERSATION_ACTIVITY_PAYWALL': 'conversation',
        'VIDEO_ACTIVITY_PAYWALL': 'video',
        'READING_ACTIVITY_PAYWALL': 'text',
        'SMART_REVIEW_PAYWALL': 'smart_review',
        'STUDY_PLAN_PAYWALL': 'study_plan',
        'MERCHANDISING_BANNER': 'merch_banner',
        'MERCHANDISING_BANNER_COUNTDOWN': 'merch_banner_countdown',
        'PRINT_PREMIUM_PAYWALL': 'lesson_summary',
        'PROMO_CART_ABANDONMENT': 'cart_abandonment',
        'PROMO_TWO_DAY_STREAK': '2_day_streak',
        'PROMO_GLOBAL': 'promo_global',
        'PROMO_BRAZE': 'promo_braze',
        'SELECT_LANG_MODAL_PAYWALL': 'multi_language',
        'PREMIUM_ACTIVITY_TOOLTIP': 'locked_content',
        'PREMIUM_CTA_NAVTOP': 'cta_navtop',
        'ONBOARDING_PLANS': 'onboarding_plans'
    };

})();

module.exports = eCommerceOriginConstants;
